import { useState } from 'react';
import { OperatorProxyRecord } from './MeshApi';

interface SelectOperatorProps {
  proxies: OperatorProxyRecord[];
  onSelect: (operatorProxy: string) => void;
}

// Shown only when the human holds more than one candidate proxy. Which organization the operator
// authority is claimed from is a property of the operation, so it is asked rather than guessed.
const SelectOperator = ({ proxies, onSelect }: SelectOperatorProps) => {
  const [selected, setSelected] = useState<string>(
    proxies.find(proxy => proxy.is_mesh_operator)?.operator_proxy ?? proxies[0]?.operator_proxy ?? '',
  );

  const label = (proxy: OperatorProxyRecord) => {
    const name = proxy.organization_name ?? proxy.operator_proxy;
    // The flag is advisory, so a proxy without it stays selectable and is only marked as unlikely.
    return proxy.is_mesh_operator ? name : `${name} (not a mesh operator)`;
  };

  return (
    <div className="form-container">
      <div className="form-group">
        <label htmlFor="operator-proxy">Act as mesh operator for:</label>
        <select
          id="operator-proxy"
          className="form-input"
          value={selected}
          onChange={event => setSelected(event.target.value)}
        >
          {proxies.map(proxy => (
            <option key={proxy.operator_proxy} value={proxy.operator_proxy}>
              {label(proxy)}
            </option>
          ))}
        </select>
        <button disabled={!selected} type="button" className="form-button" onClick={() => onSelect(selected)}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default SelectOperator;
